import React from 'react';
import { Icon } from '../ui/Icon';
import { Avatar } from '../ui/Avatar';

const TESTIMONIALS = [
  {
    n: 'Layla Al-Haddad',
    r: 'Founder · Atelier Naya',
    a: 'LH',
    color: '#8b5cf6',
    q: 'We cut shipping costs 38% in the first month. The wallet approach means no more chasing invoices from five carriers.',
  },
  {
    n: 'Omar Rashid',
    r: 'COO · Fulfilldown',
    a: 'OR',
    color: '#0ea5e9',
    q: 'The API is beautiful. We integrated in an afternoon and now push 400+ labels a day without touching a dashboard.',
  },
  {
    n: 'Maria Silva',
    r: 'Ops Lead · Tendril',
    a: 'MS',
    color: '#f97316',
    q: 'Unified tracking across DHL, Aramex and SMSA alone is worth it. Our support team stopped getting "where is my order" tickets.',
  },
];

const TestimonialsSection: React.FC = () => (
  <section className="page" style={{ paddingTop: 80 }}>
    <span className="kicker">What customers say</span>
    <h2
      style={{
        fontSize: 36,
        fontWeight: 600,
        letterSpacing: '-0.02em',
        marginTop: 12,
        maxWidth: 680,
      }}
    >
      Trusted by{' '}
      <span style={{ fontFamily: 'var(--font-disp)', fontStyle: 'italic', fontWeight: 400 }}>
        8,400+
      </span>{' '}
      businesses from solo sellers to 9-figure brands.
    </h2>
    <div className="grid-3" style={{ marginTop: 32 }}>
      {TESTIMONIALS.map((t) => (
        <div key={t.n} className="card card-pad" style={{ padding: 24 }}>
          <div style={{ display: 'flex', gap: 2 }}>
            {[...Array(5)].map((_, i) => (
              <Icon key={i} name="star" size={14} color="var(--brand-amber)" />
            ))}
          </div>
          <p style={{ marginTop: 14, fontSize: 15, lineHeight: 1.55, color: 'var(--ink-2)' }}>
            {t.q}
          </p>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 20 }}>
            <Avatar initials={t.a} style={{ background: t.color }} />
            <div>
              <div style={{ fontSize: 13, fontWeight: 600 }}>{t.n}</div>
              <div className="muted" style={{ fontSize: 12 }}>{t.r}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default TestimonialsSection;
